import moment from "moment";

const ISO_8601_DATE_TIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ssZ';
const DATETIME_DISPLAY_FORMAT = "D. M. YYYY, H:mm:ss";
const DATE_DISPLAY_FORMAT = "dddd, Do Mo YYYY";

/**
 * Converts a date and time to ISO-8601 format.
 * @param date {string} YYYY-MM-DD
 * @param time {string} HH:mm:ss
 * @returns {string|null} ISO-8601 date format or null
 */
function isoFromDateTime(date, time) {
    if (date !== null && date !== undefined && time !== null && time !== undefined) {
        return moment(date + ' ' + time, moment.HTML5_FMT.DATE + ' ' + moment.HTML5_FMT.TIME_SECONDS).format(ISO_8601_DATE_TIME_FORMAT);
    } else if (date !== null && date !== undefined) {
        return moment(date, moment.HTML5_FMT.DATE).format(ISO_8601_DATE_TIME_FORMAT);
    } else {
        return null;
    }
}

/**
 * Checks if value is a valid date string in given format
 * @param value {string}
 * @param format {string}
 * @return {boolean}
 */
function isDateStringInFormat (value, format)  {
    return moment(value, format, true).isValid();
}

export {isoFromDateTime, isDateStringInFormat, ISO_8601_DATE_TIME_FORMAT, DATETIME_DISPLAY_FORMAT, DATE_DISPLAY_FORMAT};
